export const AREAS_SUPORTE_FIXAS = [
  'SAC (Empreendimentos/DICON)',
  'Comercial (Milton/Beth/Valkiria)',
  'Controladoria (Fabio)',
]

